import { cn } from '@/shared/utils/cn';

export const navLinkClass = (
    { isActive, collapsed, nested }: { isActive: boolean; collapsed?: boolean; nested?: boolean },
) => cn(
    'flex items-center gap-3 rounded-lg px-3 py-2 font-ui text-sm transition focus-ring w-full',
    // A link inside a group sits indented under the group's label.
    nested && 'pl-9',
    // Icon rail: no label to align to, so centre the icon and drop the padding.
    collapsed && 'justify-center gap-0 px-0',
    isActive
        ? 'bg-brand-sky-50 font-semibold text-brand-navy'
        : 'text-ink-700 hover:bg-ink-50',
);
